import { useCallback } from 'react';
export function useInsertVariableIntoTextField(inputRef, onValueChange) {
    return useCallback((label)=>{
        var _input_selectionStart, _input_selectionEnd;
        const input = inputRef.current;
        if (!input) return;
        const start = (_input_selectionStart = input.selectionStart) !== null && _input_selectionStart !== void 0 ? _input_selectionStart : input.value.length;
        const end = (_input_selectionEnd = input.selectionEnd) !== null && _input_selectionEnd !== void 0 ? _input_selectionEnd : start;
        const variableText = "{{".concat(label, "}}");
        const newValue = input.value.slice(0, start) + variableText + input.value.slice(end);
        onValueChange(newValue);
        requestAnimationFrame(()=>{
            if (!inputRef.current || inputRef.current !== input) return;
            input.focus();
            const cursorPosition = start + variableText.length;
            input.setSelectionRange(cursorPosition, cursorPosition);
        });
    }, [
        inputRef,
        onValueChange
    ]);
}
